<template>
  <div class="card p-3 shadow">
    <h4 class="font-weight-bolder text-primary pb-3">پرفروش ترین ها</h4>
    <table class="table text-center">
      <thead>
      <tr>
        <th scope="col">نام محصول</th>
        <th scope="col">تعداد فروش</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in topSellProducts">
        <td>{{ item.name }}</td>
        <td class="text-center">{{ item.order_count }}</td>
      </tr>

      </tbody>
    </table>
    <div class="text-center mx-auto">
      <pagination class="mx-auto" :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";

export default {
  name: "StatisticTopSellProduct",
  components: {Pagination},
  data() {
    return {
      form: {
        page: 1
      },
      pagination: [],
      topSellProducts: [],
    }
  },
  methods: {
    getTopSellProducts(form) {
      this.$store.dispatch('Statistic/topSellProducts', form).then(res => {
        let baseData = res.data.data;
        this.topSellProducts = baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getTopSellProducts(this.form)
    },
  },
  mounted() {
    this.getTopSellProducts(this.form)
  }
}
</script>

<style scoped>

</style>